module.exports = __webpack_public_path__ + "img/5.1a73e339.png";